'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { FilterRadioGroupSection } from './filter-radio-group-section.component';

import {
  SearchFilterAgeGroupMap,
  SearchFilterAgeGroupType,
  searchFilterAgeGroupOptions,
} from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-age-group.type';

const options = searchFilterAgeGroupOptions.map((value) => ({ value, label: SearchFilterAgeGroupMap[value] }));

export const ageGroupOptionTestId = (value: SearchFilterAgeGroupType): string =>
  `${DataTestIdEnum.SEARCH_FILTERS_AGE_GROUP_OPTION}-${value}`;

interface AgeGroupFilterSectionProps {
  value: SearchFilterAgeGroupType;
  onChange: (value: SearchFilterAgeGroupType) => void;
}

export function AgeGroupFilterSection({ value, onChange }: AgeGroupFilterSectionProps) {
  return (
    <FilterRadioGroupSection
      label="Atendimento para"
      value={value}
      options={options}
      onChange={onChange}
      testId={DataTestIdEnum.SEARCH_FILTERS_AGE_GROUP}
      getOptionTestId={ageGroupOptionTestId}
    />
  );
}
